export enum FileType {
    HEALTHCARE = "HEALTHCARE",
    WORKINJURY = "WORKINJURY",
    CLAIM_REQ = "BENEFITCLAIMREQUEST",
    BENEFIT_TEMP_CLAIM_REQ = "BENEFIT_TEMP_CLAIM_REQ",
	BENEFIT_CLAIM_DOC = "BENEFIT_CLAIM_DOC",
	PRIMARY_WI = "PRIMARY_WI",
	INSPECTION_BRIEFING_NOTE = "INSPECTION_BRIEFING_NOTE",
	INSPECTION_RESULT = "INSPECTION_RESULT",
	INSPECTION_SUPPORTING_ATTACHMENT = "INSPECTION_SUPPORTING_ATTACHMENT"
}

export enum FileExtension {
    PDF = "application/pdf",
    IMAGE_JPG = "image/jpeg",
    IMAGE_PNG = "image/png",
    ZIPPED_FILE = ".zip",
    COMPRESSED_FILE = "application/x-zip-compressed"
}
